import { XmlRules } from '../xml-rules-check/xmlRules.class';
import { XmlCursorPos, XMLCursorPositions } from '../cursor/xmlCursorPos.class';
import { XmlCursorPosMover } from '../cursor/xmlCursorPosMover.class';
import { DomDummyNodeManager } from '../dummyNodes/domDummyNodeManager.class';
import { XmlCursor } from '../cursor/xmlCursor.class';

export class XmlEditDelete {
  public static deleteSelection(cursor: XmlCursor, rootNode: Element, xmlRules: XmlRules): boolean {
    return true;
  }

  public static deleteAfter(pos: XmlCursorPos, rootNode: Element, xmlRules: XmlRules): boolean {
    if (pos === undefined) {
      return false;
    }

    switch (pos.PosAtNode) {
      case XMLCursorPositions.CursorOnCompleteNode:
        return XmlEditDelete.deleteBefore(pos, rootNode, xmlRules);

      case XMLCursorPositions.CursorBehindNode:
      case XMLCursorPositions.CursorInFrontOfNode:
        XmlCursorPosMover.moveRight(pos, rootNode, xmlRules);
        return XmlEditDelete.deleteBefore(pos, rootNode, xmlRules);

      case XMLCursorPositions.CursorInEmptyNode:
        return XmlEditDelete.deleteBefore(pos, rootNode, xmlRules);

      case XMLCursorPositions.CursorInsideTextNode:
        XmlCursorPosMover.moveRight(pos, rootNode, xmlRules);
        return XmlEditDelete.deleteBefore(pos, rootNode, xmlRules);

      default:
        throw new Error(`String.Format("XmlCursorEdit.deleteBefore: unknown CursorPos ${pos.PosAtNode}`);
    }

    return true;
  }

  public static deleteBefore(pos: XmlCursorPos, rootNode: Element, xmlRules: XmlRules): boolean {
    let deleteNode: Node;

    // console.log(pos.getDebugDescription());

    if (pos === undefined) {
      return false;
    }
    switch (pos.PosAtNode) {
      case XMLCursorPositions.CursorOnCompleteNode:
        deleteNode = pos.ActualNode;
        XmlCursorPosMover.moveRight(pos, rootNode, xmlRules);
        deleteNode.parentElement.removeChild(deleteNode);
        break;

      case XMLCursorPositions.CursorBehindNode:
        if (pos.ActualNode.nodeType === Node.TEXT_NODE) {
          pos.SetCursor(pos.ActualNode, XMLCursorPositions.CursorInsideTextNode, pos.ActualNode.textContent.length);
          return XmlEditDelete.deleteBefore(pos, rootNode, xmlRules);
        } else {
          pos.ActualNode.parentElement.removeChild(pos.ActualNode);
        }
        break;

      case XMLCursorPositions.CursorInEmptyNode:
        deleteNode = pos.ActualNode;
        XmlCursorPosMover.moveRight(pos, rootNode, xmlRules);
        deleteNode.parentElement.removeChild(deleteNode);
        break;

      case XMLCursorPositions.CursorInFrontOfNode:
        deleteNode = DomDummyNodeManager.getPreviousSibling(pos.ActualNode);
        if (!deleteNode) {
          deleteNode = pos.ActualNode.parentElement;
        }
        if (deleteNode) {
          if (deleteNode.nodeType === Node.TEXT_NODE) {
            pos.SetCursor(deleteNode, XMLCursorPositions.CursorInsideTextNode, deleteNode.textContent.length);
            return XmlEditDelete.deleteBefore(pos, rootNode, xmlRules);
          } else {
            deleteNode.parentElement.removeChild(deleteNode);
          }
        }
        break;

      case XMLCursorPositions.CursorInsideTextNode:
        if (pos.PosInTextnode === 0) {
          pos.SetCursor(pos.ActualNode, XMLCursorPositions.CursorInFrontOfNode, 0);
          return XmlEditDelete.deleteBefore(pos, rootNode, xmlRules);
        } else {
          let text = pos.ActualNode.textContent;
          text = text.substring(0, pos.PosInTextnode - 1) + text.substr(pos.PosInTextnode, pos.ActualNode.textContent.length);
          pos.ActualNode.textContent = text;
          XmlCursorPosMover.moveLeft(pos, rootNode, xmlRules);
          // pos.SetCursor(pos.ActualNode, XMLCursorPositions.CursorInsideTextNode, pos.PosInTextnode - 1);
        }
        break;

      default:
        throw new Error(`String.Format("XmlEdit.deleteBefore: unknown CursorPos ${pos.PosAtNode}`);
    }

    return true;
  }
}
